export default {

    custom: {
        chartName: {
            required: 'Chart Name is required',
            max: 'Maximum number of characters is 100',
        },
    },

}
;
